import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import TemplateInput from '../../../elements/Input';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { formatDate } from './../../DatesRangeSelector/commons';
class Input extends React.Component {
  state = {
    value: dayjs(this.props.defaultValue).isValid()
      ? dayjs(this.props.defaultValue).format(this.props.format)
      : ''
  };

  updateValue = (value) => {
    const { format } = this.props;
    this.setState({ value: dayjs(value).isValid() ? dayjs(value).format(format) : '' });
  };

  clear = () => {
    this.setState({ value: '' });
  };

  onChange = ($event) => {
    const { format, onChange, minDate, maxDate, onInvalid } = this.props;
    const val = dayjs($event.target.value, format);
    if (this.props.customValidateDate) {
      if (this.props.getEmptyDate && $event.target.value === '') {
        onChange($event.target.value);
        this.setState({ value: $event.target.value });
        return;
      }
      dayjs.extend(customParseFormat);
      const date1 = dayjs($event.target.value).toDate();
      const date2 = dayjs($event.target.value, format).toDate();
      let date = date1;
      if (date2.toString() !== 'Invalid Date') {
        if (
          date1.getFullYear() !== date2.getFullYear() ||
          date1.getMonth() !== date2.getMonth() ||
          date1.getDay() !== date2.getDay()
        ) {
          date = date2;
        }
      }
      const isCorrectFormat = formatDate(date, format, this.context) === $event.target.value;
      isCorrectFormat
        ? onChange(date)
        : date1.toString() !== 'Invalid Date'
        ? onChange(date2)
        : onChange(date1);
    } else {
      let isValid = true;
      if (minDate && val.isValid()) {
        const min = dayjs(dayjs(minDate).format(format), format).toDate();
        if (!(val.isSame(min) || val.isAfter(min))) {
          isValid = false;
        }
      }
      if (maxDate && val.isValid() && isValid) {
        const max = dayjs(dayjs(maxDate).format(format), format).toDate();
        if (!(val.isSame(max) || val.isBefore(max))) {
          isValid = false;
        }
      }
      if ($event.target.value === '' && this.props.getEmptyString) {
        onChange('');
        this.setState({ value: $event.target.value });
        return;
      }
      if (isValid) {
        onChange(val.toDate());
      } else {
        onInvalid();
      }
    }

    this.setState({ value: $event.target.value });
  };

  render = () => {
    const { format, minDate, maxDate, onInvalid, onChange, defaultValue, ...rest } = this.props;
    const { value } = this.state;
    return (
      <TemplateInput
        className="fr-flex-2"
        border={false}
        value={value}
        onChange={this.onChange}
        focusReferences={(ref) => {
          this.reference = ref;
        }}
        size="10"
        dataTestId="dayPickerInput"
        {...rest}
        onKeyDown={(e) => {
          this.props.onKeyPress(e);
        }}
      />
    );
  };
}

Input.propTypes = {
  defaultValue: PropTypes.instanceOf(Date),
  format: PropTypes.string,
  id: PropTypes.string,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func,
  onInvalid: PropTypes.func,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  placeholder: PropTypes.string,
  ariaLabel: PropTypes.string,
  bgColor: PropTypes.string,
  textTruncate: PropTypes.bool,
  getEmptyDate: PropTypes.bool,
  customValidateDate: PropTypes.bool
};

Input.defaultProps = {
  defaultValue: null,
  format: 'MM/DD/YYYY',
  id: null,
  onFocus: () => {},
  onClick: () => {},
  onKeyDown: () => {},
  onChange: () => {},
  onInvalid: () => {},
  minDate: null,
  maxDate: null,
  placeholder: null,
  ariaLabel: null,
  bgColor: 'transparent',
  textTruncate: true,
  getEmptyDate: false,
  customValidateDate: false
};

export default Input;
